import React, { useState, useEffect, useRef, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../locales/translations';
import { LOGO_URL } from '../assets/index';

const SalesToast = () => {
  const { language } = useLanguage();
  const text = t[language].salesToast;
  const [isVisible, setIsVisible] = useState(false);
  const [toastData, setToastData] = useState(null);
  const intervalRef = useRef(null);
  const hideTimerRef = useRef(null);

  const showToast = useCallback((currentText) => {
    const seed = Math.floor(Date.now() / 1000);
    setToastData({
      name: currentText.names[seed % currentText.names.length],
      location: currentText.locations[(seed * 2) % currentText.locations.length],
      plan: currentText.plans[(seed * 3) % currentText.plans.length],
      time: (seed % 59) + 1,
    });
    setIsVisible(true);
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    hideTimerRef.current = setTimeout(() => setIsVisible(false), 5000);
  }, []);

  useEffect(() => {
    // Hide any active toast immediately on language change
    setIsVisible(false);
    setToastData(null);
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    if (intervalRef.current) clearInterval(intervalRef.current);

    const initialTimer = setTimeout(() => {
      showToast(text);
      intervalRef.current = setInterval(() => {
        showToast(t[language].salesToast);
      }, Math.floor(Math.random() * 13000) + 12000);
    }, 5000);

    return () => {
      clearTimeout(initialTimer);
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    };
  }, [language]);

  if (!toastData) return null;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.9 }}
          transition={{ type: 'spring', stiffness: 400, damping: 25 }}
          className="fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-[100] bg-[#12121a] border border-white/10 rounded-2xl p-3 sm:p-4 shadow-2xl flex items-center gap-4 max-w-[320px] sm:max-w-sm"
        >
          <div className="w-12 h-12 rounded-xl bg-purple-900/40 border border-purple-500/20 flex items-center justify-center shrink-0">
            <img src={LOGO_URL} alt="LovaGO" className="w-6 h-6 object-contain" />
          </div>
          <div>
            <p className="text-white text-sm font-medium leading-tight mb-1">
              {toastData.name} {text.action}
            </p>
            <p className="text-purple-400 font-bold text-sm mb-1">
              {toastData.plan}
            </p>
            <p className="text-gray-500 text-xs">
              {toastData.location} · {text.ago} {toastData.time} {text.min}
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SalesToast;